/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 2/2/16.
 */
'use strict';
angular.module('prism-ui.calendars').controller('CalendarsViewController',
	function (
        $interval,
        $location,
	    $q,
	    $scope,
        CalendarColumnsFactory,
        CalendarsFilterService,
        CalendarsQueryService,
        DynamicPropertiesService,
        NavbarUtilService,
        PermissionsService,
        SearchFilterService
    ) {
		var self = this, refreshInterval, originalActiveData = {},
            refreshDelay;
		self.breadCrumb = 'Calendars';
		self.activeData = {};
		self.activeColumnDefs = [];
		self.showTodayOnly = false;
		self.zoomLevel = 0;

		self.canReadLiveRecordings = null;
		self.activeTabs = {
			dueDate: false,
			ord: false,
			firstLaunch: false,
			liveRecordings: false
		};

		self.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		var setCalSearchText = function (searchText) {
			CalendarsFilterService.searchText =  searchText ? searchText : '';
		};

		var handleRefresh = function (tab) {
			self.executeQuery(tab, true);
		};

		var filterData = function () {
			var newData = {};
			if (self.showTodayOnly) {
				newData = CalendarsFilterService.filterToday(originalActiveData, self.currentTab);
			}
			else {
				newData = CalendarsFilterService.executeSearch(originalActiveData);
			}
			return newData;
		};

		self.executeQuery = function (newTab, isRefresh) {
			$scope.$broadcast('server-busy', {working: true});
			let promises = [];
			if (self.canReadLiveRecordings === null) {
			    promises.push(PermissionsService.isSystemOperator().then(function (isSystemOperator) {
			        self.canReadLiveRecordings = isSystemOperator;
                }));
            }
			promises.push(CalendarsQueryService[newTab + 'Query'](self.includeDelivered).then(function (data) {
				if (!isRefresh) {
				    for (var tabName in self.activeTabs) {
                        self.activeTabs[tabName] = (tabName === newTab);
                    }
					self.activeColumnDefs = CalendarColumnsFactory[newTab + 'Columns'];
					self.currentTab = newTab;
				}
				originalActiveData = angular.copy(data);
			}));
			$q.all(promises).then(function () {
			    if (!self.canReadLiveRecordings && self.currentTab === 'liveRecordings') {
                    originalActiveData = {};
                }
				self.activeData = filterData();
				$scope.$broadcast('server-busy', {working: false});
            });
		};

		self.activateTab = function (tab) {
			$location.search('subView', tab);
			if (self.currentTab !== tab) {
				self.currentTab = tab;
				self.includeDelivered = tab === 'ord' || tab === 'firstLaunch';
				$interval.cancel(refreshInterval);
				DynamicPropertiesService.queryForProperties().then(() => {
                    refreshDelay = DynamicPropertiesService.getPropValueAsInt('calendars.refreshInterval', 60000);
				    refreshInterval = $interval(handleRefresh, refreshDelay, 0, true, tab);
    				self.executeQuery(tab, false);
                });
			}
		};

		self.todayClicked = function () {
			self.showTodayOnly = true;
			self.activeData = CalendarsFilterService.filterToday(originalActiveData, self.currentTab);
		};

		self.showAllClicked = function () {
			self.showTodayOnly = false;
			self.activeData = CalendarsFilterService.executeSearch(originalActiveData);
		};

		self.zoom = function (zoomPixels) {
			var newDefs = angular.copy(self.activeColumnDefs);
			if ((zoomPixels < 0 && self.zoomLevel > 0) || zoomPixels > 0 && self.zoomLevel < 10) {
				angular.forEach(newDefs, function (columnDef) {
					if (columnDef.enableColumnResizing) {
						columnDef.width = columnDef.width + zoomPixels;
					}
				});
				if (zoomPixels >= 0) {
					self.zoomLevel++;
				}
				else {
					self.zoomLevel--;
				}
			}
			self.activeColumnDefs = newDefs;
		};

		self.disableZoomIn = function () {
			return self.zoomLevel >= 10;
		};

		self.disableZoomOut = function () {
			return self.zoomLevel <= 0;
		};

		$scope.$on('server-busy', function (event, options) {
			self.loadingIndicator.show = options.working;
		});

		$scope.$on('$destroy', function () {
			$interval.cancel(refreshInterval);
		});

        SearchFilterService.populateCriteriaFromLocationSearch();
		NavbarUtilService.viewSearchFunction = function (searchText) {
			setCalSearchText(searchText);
			self.activeData = filterData();
		};
		setCalSearchText($location.search().searchText);
		self.activateTab($location.search().subView || 'dueDate');
	});
